import isSvg from 'is-svg';
import isUrl from 'is-url';

const {
  blocks: { createBlock },
} = wp;

const transforms = {
  from: [
    {
      type: 'block',
      blocks: ['b3rg/video'],
      transform: (attributes) => {
        return createBlock('core/image', {
          useExtendedAttributes: true,
          blockClassNames: attributes.blockClassNames,
          id: attributes.videoPosterImage?.id ?? '',
          url: attributes.videoPosterImage?.url ?? '',
        });
      },
    },
    {
      type: 'block',
      blocks: ['b3rg/icon-block'],
      transform: (attributes) => {
        return createBlock('core/image', {
          useExtendedAttributes: true,
          blockClassNames: attributes.blockClassNames,
          id: attributes.attachmentId,
          url: attributes.icon ? attributes.icon : attributes.iconName,
        });
      },
    },
  ],
  to: [
    {
      type: 'block',
      blocks: ['b3rg/video'],
      transform: (attributes) => {
        return createBlock('b3rg/video', {
          blockClassNames: attributes.blockClassNames,
          videoUpload: {
            id: attributes.id,
          },
          videoPosterImage: {
            id: attributes.id,
            url: attributes.url,
          },
        });
      },
    },
    {
      type: 'block',
      blocks: ['b3rg/icon-block'],
      transform: (attributes) => {
        const updatedAttributes = {
          blockClassNames: attributes.blockClassNames,
          attachmentId: attributes.id,
        };
        if (isUrl(attributes.url)) {
          updatedAttributes.iconName = attributes.url;
          updatedAttributes.iconExtension = attributes.url.split('.').pop();
        } else if (isSvg(attributes.url)) {
          updatedAttributes.icon = attributes.url;
        } else {
          updatedAttributes.iconName = attributes.url;
        }
        return createBlock('b3rg/icon-block', updatedAttributes);
      },
    },
  ],
};

export default transforms;
